import React, { useCallback, useRef, useState } from 'react';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import { LanguageSelector } from '../LanguageSelector';
import { FormattedMessage, useIntl } from 'react-intl';

const containerStyles = {
  position: 'absolute' as const,
  top: 16,
  right: 16,
  zIndex: 10,
};
const menuAnchorOrigin = { vertical: 'bottom', horizontal: 'right' } as const;
const menuTransformOrigin = { vertical: 'top', horizontal: 'right' } as const;

const buttonStyles = (theme) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3)',
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
});

const AuthMenuButton = () => {
  const intl = useIntl();
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => {
    setOpen((currentOpen) => !currentOpen);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <div style={containerStyles}>
      <IconButton
        ref={anchorRef}
        size="small"
        sx={buttonStyles}
        onClick={handleToggle}
        title={intl.formatMessage({
          id: 'userMenu.account',
          defaultMessage: 'Account',
        })}
        aria-label={intl.formatMessage({
          id: 'userMenu.accountMenu',
          defaultMessage: 'Account menu',
        })}
      >
        <PersonIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={menuAnchorOrigin}
        transformOrigin={menuTransformOrigin}
      >
        <LanguageSelector />
        <Divider />
        <MenuItem component={Link} to="/signin" onClick={handleClose}>
          <FormattedMessage id="userMenu.signIn" defaultMessage="Sign In" />
        </MenuItem>
        <MenuItem component={Link} to="/signup" onClick={handleClose}>
          <FormattedMessage id="userMenu.signUp" defaultMessage="Sign Up" />
        </MenuItem>
      </Menu>
    </div>
  );
};

export { AuthMenuButton };
